module.exports = require("./lib/_stream_transform.js")



/*****************
 ** WEBPACK FOOTER
 ** ../~/stream-browserify/~/readable-stream/transform.js
 ** module id = 1010
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/stream-browserify/~/readable-stream/transform.js
 ** module id = 1010
 ** module chunks = 1
 **/